import { useMemo } from 'react';

import { useGetProxiesQuery } from 'store/api';

export function useHasProxies() {
  const { data: proxies, isLoading } = useGetProxiesQuery({ page: 1, perPage: 10 });

  const hasProxies = useMemo(() => {
    if (!proxies?.data) return false;

    return proxies.data.length > 0;
  }, [proxies?.data]);

  return [hasProxies, isLoading] as const;
}
